import './index.scss';

import classNames from 'clsx';
import React, { FC } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';

import UserInfo from '../user-info';

const pageList = [
  { label: '首页', key: 'index', path: '/home', },
  { label: '对接方案', key: 'connectPlan', path: '/connect-plan', },
  { label: '联系我们', key: 'contactUs', path: '/contact-us', },
  { label: '控制台', key: 'admin', path: '/admin', },
];

export const Header: FC = () => {

  const match = useRouteMatch();


  return (
    <div className="layout-header">
      <div className="header__logo" style={{position: 'relative'}}>
        <img className='logo-white'  src='https://view.didistatic.com/static/dcms/4l071274mlps6gcv4_258x32.png' />
        <img className='logo-black' style={{position: 'absolute', left: 0}} src='https://view.didistatic.com/static/dcms/19aoig2hrlps6grj2_515x64.png' />
      </div>

      <ul className="header__menu">
        {
          pageList.map(it => (
            <li
              key={it.key}
              className={classNames({
                'menu-link': true,
                'menu-link--active': match.path === it.path,
              })}
            >
              <Link to={it.path}>{it.label}</Link>
            </li>
          ))
        }
      </ul>

      <div className="header__avatar">
        <UserInfo />
      </div>
    </div>
  )
};
